<template>
    <kgr-form-scaffold
        :with-primary-buttons="false"
        @backBtnClicked="redirectToOverview"
    >
        <kgr-member-short-profile-data-provider
            v-slot="memberScope"
            :member-id="memberId"
        >
            <div class="animated fadeIn">
                <kgr-member-short-profile :member-short-profile="memberScope.data" />
            </div>
        </kgr-member-short-profile-data-provider>
    </kgr-form-scaffold>
</template>

<script>
import KgrFormScaffold from '../../components/common/form/FormScaffold';
import KgrMemberShortProfile from '../../components/members/MemberShortProfile';
import KgrMemberShortProfileDataProvider from '../../components/data-provider/MemberShortProfileDataProvider';

export default {
    name: 'kgr-member-show',
    components: {
        KgrMemberShortProfileDataProvider,
        KgrMemberShortProfile,
        KgrFormScaffold,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        memberId: {
            type: Number,
            required: true,
        },
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
